module.exports = __webpack_public_path__ + "static/media/Avenir-LightOblique.0e057a2e.ttf";